<script>
  import {onMount} from 'svelte';
  import EmojiSelector from './EmojiSelector.svelte';
  import {hideModal, showModal} from "../modal/modalStore";
  import Emoji from "./Emoji.svelte";
  import {showSnackbar} from "../snackbar/snackbarStore";
  import {myChannels, selectChannel} from './channelStore';
  import _ from 'lodash';
  import firebase from 'firebase';
  import Loading from "../general/Loading.svelte";

  export let onSubmit;

  export let channel;

  let nameInput;

  let name = channel ? channel.data().name : '';
  let description = channel ? (channel.data().description || '') : '';
  let emoji = channel ? channel.data().emoji : null;
  let lockCode = null; // TODO: 여기서 지정할지?

  let loading = false;

  const _onSubmit = async e => {
    e.preventDefault();
    if (!name) {
      showSnackbar(`'Name' is required`);
      return;
    }

    if (_.find($myChannels, c => c.id !== _.get(channel, 'id') && c.data().name === name)) {
      showSnackbar(`You already have a channel named '${name}'`);
      return;
    }

    if (channel) {
      firebase.firestore().collection('channels').doc(channel.id).update({
        name,
        description,
        emoji,
        modified: firebase.firestore.FieldValue.serverTimestamp()
      });
      onSubmit && onSubmit();
      return;
    }

    const newChannelDoc = firebase.firestore().collection('channels').doc();

    loading = true;
    await newChannelDoc.set({
      name,
      description,
      emoji,
      userId: firebase.auth().currentUser.uid,
      isFavorite: false,
      created: firebase.firestore.FieldValue.serverTimestamp(),
      modified: firebase.firestore.FieldValue.serverTimestamp()
    });
    loading = false;

    selectChannel(newChannelDoc);
    onSubmit && onSubmit();
  };

  const modalId = 'channel-form-' + Date.now();
  const showEmojiSelector = () => {
    showModal(EmojiSelector, {
      id: modalId,
      modalProps: {
        title: 'Select an emoji'
      },
      contentProps: {
        onSelectEmoji: e => {
          emoji = e;
          hideModal(modalId);
        }
      }
    });
  };

  onMount(() => {
    nameInput.select();
  });
</script>


<form on:submit={_onSubmit}>

  <column>
    <row class="form-item" align-center>
        {#if emoji}
          <flex center class="emoji-wrap">
            <Emoji emoji={emoji}/>
          </flex>
        {:else}
          <ion-icon name="scan-outline"></ion-icon>
        {/if}
      <button class="expand clickable" type="button" on:click={showEmojiSelector}>Click here to select an emoji</button>
    </row>
    <row class="form-item" align-center>
      <ion-icon name="cube-outline"></ion-icon>
      <input class="expand" type="text" placeholder="Name" bind:value={name} bind:this={nameInput}>
    </row>
    <row class="form-item" align-center>
      <ion-icon name="menu-outline"></ion-icon>
      <input class="expand" type="text" placeholder="Description (optional)" bind:value={description}>
    </row>
    <button type="submit" class="clickable">Submit</button>
  </column>
</form>

{#if loading}
  <div class="mask">
    <div class="loading-wrap">
      <Loading/>
    </div>
  </div>
{/if}

<style>
  .form-item {
    height: 40px;
    margin: 0 8px;
  }

  .form-item ion-icon, .form-item .emoji-wrap {
    width: 32px;
    font-size: 20px;
  }

  .form-item button {
    text-align: left;
    padding: 0;
  }

  button, input {
    background: none;
    border: none;
    align-self: stretch;
    font-size: .9rem;
  }

  button[type=submit] {
    margin-top: 8px;
    height: 40px;
    border-top: 1px solid #ccc;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .loading-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>